<div class="container" style="margin-top: 10%;">
  <!-- <h3>Carga de imágenes {{propiedad.id}}</h3> -->
<div class="container" style="margin-top: 10%;" *ngIf="propiedad">
  <h3 class="text-center">
    {{ propiedad.domicilio.calle }} {{ propiedad.domicilio.numero }}
    <span class="h4">, {{ propiedad.domicilio.barrio.localidad.descripcion }}</span>
  </h3>
</div>
  
  <!-- Zona Drag & Drop -->
  <div class="dropzone"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (drop)="onDrop($event)">
    <p>Arrastrá y soltá tus imágenes aquí</p>
    <p>o hacé click para seleccionarlas</p>
    <input type="file" multiple (change)="detectFiles($event)" hidden #fileInput>
    <button type="button" class="btn btn-outline-primary btn-sm mt-2"
            (click)="fileInput.click()">Seleccionar archivos</button>
  </div>

  <!-- Vista previa -->
  <div class="mt-3">
    <app-card-image 
      (ImgUp)="uploadFiles($event)" 
      (Close)="cancelar()" 
      [imagenes]="imgs">
    </app-card-image>
  </div>
</div>
